export default __webpack_public_path__ + "static/media/Vambraces of the Proven Champion.e79d85d1.jpg";